import { Lock, Mail, Key } from 'lucide-react';

export const TEXT_INPUT_PLACEHOLDERS = {
  EMAIL: 'Email Address',
  USERNAME: 'Username',
  PASSWORD: 'At least 8 characters',
  CONFIRM_PASSWORD: 'At least 8 characters',
  VERIFICATION_CODE: 'Enter your code',
  SEARCH: 'Search',
  NAME: 'Display Name',
  BIO: 'Let us know about yourself',
  TEAM: 'Select a team',
  COUNTRY: 'Select a country',
};
export const TEXT_INPUT_LABELS = {
  EMAIL: 'Email Address',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  VERIFICATION_CODE: 'Verification code',
  CODE: 'Code',
  SHOW_TITLE: 'Show Title',
  NAME: 'Display Name',
  BIO: 'Bio',
  TEAM: 'Team',
  COUNTRY: 'Country',
  BIRTHDAY: 'Date of Birth',
};

export const TEXT_INPUT_ICONS = {
  EMAIL: 'email',
  PASSWORD: 'password',
  CONFIRM_PASSWORD: 'confirmPassword',
  VERIFICATION_CODE: 'verificationCode',
};

export const ICONS = {
  [TEXT_INPUT_ICONS.EMAIL]: Mail,
  [TEXT_INPUT_ICONS.PASSWORD]: Lock,
  [TEXT_INPUT_ICONS.CONFIRM_PASSWORD]: Lock,
  [TEXT_INPUT_ICONS.VERIFICATION_CODE]: Key,
};
